import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBonus } from 'core/actions/bonus';
import HtmlText from 'core/modules/HtmlText/HtmlText';
import {
  selectBonusTiersConfig, selectBonusTiersIsLoading,
  selectBonusTiersIsLoaded, selectBonusTerms, selectBonusTiers,
} from 'core/modules/BonusTiers/selectors';
import { selectPageName } from 'core/selectors/app';

import { triggerBonusTermsIsViewed } from './actions';

function BonusTerms() {
  const config = useSelector(selectBonusTiersConfig);
  const isLoading = useSelector(selectBonusTiersIsLoading);
  const isLoaded = useSelector(selectBonusTiersIsLoaded);
  const bonusTerms = useSelector(selectBonusTerms);
  const bonusTiers = useSelector(selectBonusTiers);
  const pageName = useSelector(selectPageName);
  const dispatch = useDispatch();

  const [hasAutomaticPlacement, setHasAutomaticPlacement] = useState(false);

  const isHomePage = pageName === 'h';

  useEffect(() => {
    if (!isLoading && !isLoaded) {
      const { api: { params, options } } = config;
      dispatch(fetchBonus(params, options));
    }
  }, []);

  useEffect(() => {
    if (!isLoading && isLoaded) {
      const result = bonusTiers?.bonus?.some(bonus => bonus.isAutomaticPlacement);
      setHasAutomaticPlacement(result);
    }
  }, [isLoading, isLoaded, bonusTiers]);

  useEffect(() => {
    dispatch(triggerBonusTermsIsViewed());
  }, []);

  const shouldRenderSection = !isHomePage && bonusTerms || bonusTerms && isHomePage && hasAutomaticPlacement;

  if (!shouldRenderSection) {
    return null;
  }

  return <HtmlText text={`*${bonusTerms}`} testAttrName="bonus-terms" />;
}

export default BonusTerms;
